<template>
  <div class="section">
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/admin">Admin Settings</router-link></li>
        <li class="is-active"><router-link to="/admin/user-login-report" aria-current="true">User Login Report</router-link></li>
      </ul>
    </nav>
    <div class="container">
      <h1 class="title">User Login Report</h1>

      <!-- Filters -->
      <div class="field is-grouped mt-3">
        <div class="control">
          <input v-model="filters.start_date" class="input is-small" type="date" placeholder="Start Date">
        </div>
        <div class="control">
          <input v-model="filters.end_date" class="input is-small" type="date" placeholder="End Date">
        </div>
        <div class="control">
          <input v-model="filters.user_id" class="input is-small" type="text" placeholder="User ID">
        </div>
        <div class="control">
          <select v-model="filters.user_type" class="input is-small">
            <option value="">All Types</option>
            <option value="Admin">Admin</option>
            <option value="Staff">Staff</option>
            <option value="User">User</option>
          </select>
        </div>
        <div class="control">
          <button class="button is-primary is-small" @click="applyFilters">Apply Filters</button>
        </div>
        <div class="control">
          <button class="button is-warning is-small" @click="resetFilters">Reset Filters</button>
        </div>
        <div class="control">
          <button class="button is-success is-small" @click="downloadCSV">Download CSV</button>
        </div>
      </div>

      <!-- Logs Table -->
      <table class="table is-fullwidth is-small mt-5">
        <thead>
          <tr>
            <th class="is-size-7">User</th>
            <th class="is-size-7">User Type</th>
            <th class="is-size-7">IP Address</th>
            <th class="is-size-7">Login Time</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="log in logs" :key="log.id">
            <td class="is-size-7">{{ log.user ? log.user.username : '' }}</td>
            <td class="is-size-7">{{ log.user_type }}</td>
            <td class="is-size-7">{{ log.ip_address }}</td>
            <td class="is-size-7">{{ new Date(log.login_time).toLocaleString() }}</td>
          </tr>
        </tbody>
      </table>
      <button v-if="nextPage" class="button is-primary is-small" @click="fetchLogs(nextPage)">Load More</button>
    </div>
  </div>
</template>

  
  <script>
  import axios from 'axios';
  import { toast } from "bulma-toast";
  
  export default {
    name: 'UserLoginReport',
    data() {
      return {
        logs: [],
        nextPage: null,
        filters: {
          start_date: '',
          end_date: '',
          user_id: '',
          user_type: '',
          branch: '',
        },
      };
    },
    methods: {
      async fetchLogs(url = null, append = true) {
        const apiUrl = url || '/api/v1/user-login-report/';
        try {
          const response = await axios.get(apiUrl, {
            headers: { 'Authorization': `Token ${localStorage.getItem('token')}` },
            params: this.filters, // Apply filters
          });
          if (append) {
            this.logs = this.logs.concat(response.data.results);
          } else {
            this.logs = response.data.results;
          }
          this.nextPage = response.data.next;
        } catch (error) {
          console.error('Error fetching logs:', error);
          toast({
            message: "Failed to load logs. Please try again.",
            type: "is-danger",
            duration: 5000,
            position: "top-right",
          });
        }
      },
      applyFilters() {
        this.fetchLogs(null, false); // Fetch logs with updated filters
      },
      resetFilters() {
        this.filters = {
          start_date: '',
          end_date: '',
          user_id: '',
          user_type: '',
          branch: '',
        };
        this.fetchLogs(null, false); // Refresh logs
      },
      async downloadCSV() {
        try {
          const response = await axios.get('/api/v1/user-login-report/csv/', {
            headers: { 'Authorization': `Token ${localStorage.getItem('token')}` },
            params: this.filters,
            responseType: 'blob',
          });
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'user_login_report.csv');
          document.body.appendChild(link);
          link.click();
          link.remove();
          toast({
            message: "CSV downloaded successfully.",
            type: "is-success",
            duration: 3000,
            position: "top-right",
          });
        } catch (error) {
          console.error('Error downloading CSV:', error);
          toast({
            message: "Failed to download CSV. Please try again.",
            type: "is-danger",
            duration: 5000,
            position: "top-right",
          });
        }
      },
    },
    async created() {
      await this.fetchLogs();
    },
  };
  </script>
  
  <style scoped>
  .filters {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 1rem;
  }
  </style>
  